<template>
    <div class="activeInnerFrameWrap">
        <div class="activeSelectWrap">
            <div class="currentActiveName">{{conferenceName}}     <!-- {{currentPageUrlKey}} --></div>
            <div class="toggleActiveWrap" @click="isShowActiveListModal=true">
                (切换活动<i class="el-icon-refresh"></i>)
            </div>
        </div>
        <div class="tabWrap">
            <!-- {{currentPageUrlKey}} -->
            
            <div class="hrefTabWrap" v-if="currentConferenceId">
                <div style="display: none;">
                    计算属性：
                    {{function_activeinner_brandMenu }}{{function_activeinner_customerMenu}}{{function_activeinner_orderMenu}}{{function_activeinner_productMenu}}{{function_activeinner_pageMenu}}

                </div>
                <p class="tabItem" @click="toPage(list)" v-if="list.isShow" v-for="(list,index) in tabsData" :class="{active:currentPageUrlKey.search(list.key)>-1}">
                    <span class="text">{{list.text}}</span>

                </p>
            </div>

        </div>
        <div class="plainBreadCrump" v-if="currentPageUrlKey.search('intro')==-1">
            <span class="spanBtn" @click="backPage">返回</span>
            <span v-for="(list,index) in breadList">
                <span>{{list.text}}</span>
                <span v-if="index!=0&&index!=breadList.length-1">></span>
            </span>
        </div>
        <el-dialog title="活动列表" :visible.sync="isShowActiveListModal"  center>
            <div class="dialogContent">
                <div class="conferenceItemBox" v-for="(list,index) in activeWords" @click="changeConferenceId(list)" :class="{active:currentConferenceId==list.value}" >
                    <span style="margin-right: 10px;"> {{list.text}}</span>  <i class="el-icon-check" v-if="currentConferenceId==list.value"></i>
                </div>
            </div>
            
           <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="isShowActiveListModal = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>

        <router-view />
    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                isShowActiveListModal:false,
                currentConferenceId: '',
                currentPageUrlKey: '',
                breadList: [],
                tabsData: [{
                        text: '活动概况',
                        key: 'intro',
                        components: 'activeInnerIntro',
                        isShow:true,
                    },
                    {
                        text: '品牌商管理',
                        key: 'brand',
                        components: 'activeInnerBrand',
                        isShow:true,
                    },
                    {
                        text: '客户管理',
                        key: 'buyer',
                        components: 'activeInnerBuyer',
                        isShow:true,
                    },
                    {
                        text: '订单管理',
                        key: 'order',
                        components: 'activeInnerOrder',
                        isShow:true,
                    },
                    {
                        text: '商品管理',
                        key: 'product',
                        components: 'activeInnerProduct',
                        isShow:true,
                    },
                    {
                        text: '页面管理',
                        key: 'article',
                        components: 'activeInnerArticle',
                        isShow:true,
                    },
                ],
                activeWords: [],
                msg: 'Welcome to Your Vue.js App'
            }
        },
        computed:{
            function_activeinner_brandMenu(){
                let _this=this
                let result=utils.getCurrentFunction().indexOf("activeinner_brandMenu")>-1
                _this.tabsData.forEach(function(item,index){
                    if(item.text=="品牌商管理"){
                        item.isShow=result
                    }
                })
                return result
            },
            function_activeinner_customerMenu(){
                let _this=this

                let result=utils.getCurrentFunction().indexOf("activeinner_customerMenu")>-1
                _this.tabsData.forEach(function(item,index){
                    if(item.text=="客户管理"){
                        item.isShow=result
                    }
                })
                return result
            },
            function_activeinner_orderMenu(){
                let _this=this

                let result=utils.getCurrentFunction().indexOf("activeinner_orderMenu")>-1
                _this.tabsData.forEach(function(item,index){
                    if(item.text=="订单管理"){
                        item.isShow=result
                    }
                })
                return result
            },
            function_activeinner_productMenu(){
                let _this=this

                let result=utils.getCurrentFunction().indexOf("activeinner_productMenu")>-1
                _this.tabsData.forEach(function(item,index){
                    if(item.text=="商品管理"){
                        item.isShow=result
                    }
                })
                return result
            },
            function_activeinner_pageMenu(){
                let _this=this

                let result=utils.getCurrentFunction().indexOf("activeinner_pageMenu")>-1
                _this.tabsData.forEach(function(item,index){
                    if(item.text=="页面管理"){
                        item.isShow=result
                    }
                })
                return result
            },
            conferenceName(){
              let _this=this
              let result=""
              let val=_this.currentConferenceId
              let word=_this.activeWords
              if (!val){
              		result="暂无活动"
              	} else if(!word){
              		result="-"
              	}else{
              		word.forEach(function(item,index){
              			if(item.value==val){
              				result=item.text
              				return 
              			}
              		})
              	}
              	return result
          }  
        },
        watch: {
            '$route': {
                immediate: true,
                handler: function(to, from) {
                    let _this = this
                    let path = to.path
                    this.currentPageUrlKey = path
                    if(this.currentPageUrlKey=='/active/activeInner'){
                        console.log("活动列表第一页111111111111111-------------------------------------")
                        _this.toPage(_this.tabsData[0])
                    }
                    // console.log(to.matched)
                    _this.breadList = []
                    if (to.matched && to.matched.length > 0) {
                        to.matched.forEach(function(item1, index1) {
                            // console.log(item1)
                            let buffer = {
                                path: item1.path,
                                text: item1.meta.title,
                            }
                            _this.breadList.push(buffer)
                        })
                    }
                    // 
                }
            }
        },
        methods: {
            changeConferenceId(list) {
                let _this = this
                _this.currentConferenceId=list.value
                sessionStorage.setItem("ActiveModuleCurrentConferenceId",_this.currentConferenceId)
                this.$router.push({
                    name: 'activeInnerIntro',
                    params: {
                        conferenceId: _this.currentConferenceId
                    }
                });
                _this.isShowActiveListModal=false

            },
            backPage() {
                this.$router.back()
            },
            toPage(list) {
                console.log("topage跳转")
                console.log(list)
                let _this = this
                let url = list.components
                this.$router.push({
                    name: url,
                    params: {
                        conferenceId: _this.currentConferenceId
                    }
                });
                // this.$router.push({path: '/active/activeInner/'+key, query: {conferenceId:_this.currentConferenceId}  });
            },
            getActiveOption() {
                let _this = this
                let arg = {
                    userId: 1
                }
                console.log("获取活动选项")
                ajaxPost('/admin/getconferenceList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.activeWords = []
                        res.data.forEach(function(item, index) {
                            let buffer = {
                                text: item.conferenceName,
                                value: item.conferenceId,
                                // userInviteCode:item.userInviteCode
                            }
                            _this.activeWords.push(buffer)
                        })
                        // 设置第一个默认值
                        let sessionConferenceId=sessionStorage.getItem("ActiveModuleCurrentConferenceId")
                        if(sessionConferenceId){
                            _this.currentConferenceId=sessionConferenceId
                        }else{
                            _this.currentConferenceId = _this.activeWords[0].value
                            console.log("没有存在默认的活动id,开始跳转到初始默认页面-------------------")
                            // _this.toPage(_this.tabsData[0])
                            _this.toPage("")
                        }
                       
                    }


                }, function(res) {})
            }
        },
        mounted() {
            this.getActiveOption()
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue}
    .activeInnerFrameWrap {
        .plainBreadCrump {
            background: #fff;
            line-height: 40px;
            height: 40px;
            font-size: 12px;
            padding-left: 30px;
            color: #565656;

            span {
                margin-right: 5px;
            }
        }

        .activeSelectWrap {
            background: #00A0E9; color:#fff; text-align: center; height:50px; padding:5px 0; line-height: 50px;
            .toggleActiveWrap{display: inline-block;padding:0 5px; }
            .toggleActiveWrap:hover{cursor: pointer;color:lightblue;}
            .currentActiveName {
                display: inline-block; 
                font-size: 22px; letter-spacing: 1px;
            }
        }

        .tabWrap {
            display: flex;
            border-bottom: 2px solid #ddd;
            .hrefTabWrap {
                display: flex;

                .tabItem {
                    text-align: center;
                    padding: 15px 20px 5px;
                    .text::after {content: '——';     width: 100%;      color:#eee;        display: block; line-height: 5px;  }
                }

                .tabItem:hover,
                .tabItem.active {
                    color: #3c9fdb;
                    cursor: pointer;

                    .text::after {
                        content: '——';
                        width: 100%;
                        color: #3c9fdb;
                        display: block;
                        line-height: 5px;
                    }

                }


            }
        }
        .dialogContent{text-align: center;
            .conferenceItemBox{background: #efe;margin-bottom: 10px;padding:10px;cursor: pointer; text-align: center;font-size: 18px; display:block;}
            .conferenceItemBox.active{background: #00A0E9;color:#fff;}
        }
        
        
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/frameInner.vue